import { useAuth0 } from "@auth0/auth0-react";
import Action from "components/ActionPopOver";
import AlertDialog from "components/Dialog";
import MyTable from "components/Table";
import { searchRequest } from "hook/searchRequest";
import FinanceService from "Lib/API/Finance";
import { addSubCategorys } from "pages/School/Classes/classSlice";
import React from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory, useParams } from "react-router";
import "../index.scss";

const ActivatedSubCategories = ({
  setEdit,
  setData,
  setEditClicked,
  refresh,
  setRefresh,
  ledgerName,
  ledger_id,
  searchText,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [table, setTable] = React.useState([]);
  const [deleteClicked, setDeleteClicked] = React.useState(false);
  const [subId, setSubId] = React.useState("");
  const rowsPerPage = 15;
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();
  const params = useParams();
  const handleCloseDialog = () => {
    setOpenAlert(false);
  };
  const enableLoading = (value) => {
    setLoading(value);
  };
  const handleChange = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.updateSubcategorie(
      { subCategory_id: subId, activated: false },
      token
    )
      .then((res) => {
        if (res) {
          setOpenAlert(false);
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };
  const handleDelete = async () => {
    const token = await getAccessTokenSilently();
    await FinanceService.removeSubcateggorie({ subCategory_id: subId }, token)
      .then((res) => {
        if (res) {
          handleCloseDialog();
          setRefresh(!refresh);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      if (params?.ledger_id === "1") {
        await FinanceService.getFilteredSubcaegories(
          "filter?active=true",
          token
        )
          .then((res) => {
            if (res.length) {
              res.map((item) => {
                item.id = item._id;
                return item;
              });
              setTable(res);
              setList(res);
            } else setList([]);
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
      } else
        await FinanceService.getSubcategoriesByLedgerAccountFiltered(
          "?active=true",
          ledger_id,
          token
        )
          .then((res) => {
            if (res.length) {
              const subCat = [];
              res.map((item) => {
                subCat.push({
                  value: item?._id,
                  label: item?.sub_cat_name,
                });
                item.id = item._id;
                return item;
              });
              setTable(res);
              setList(res);
              dispatch(addSubCategorys(subCat));
            } else setList([]);
            enableLoading(false);
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
    }
    fetchMyAPI();
    enableLoading(true);
  }, [getAccessTokenSilently, history, refresh, ledger_id, dispatch]);

  const columns = [
    {
      field: "sub_cat_id",
      resizable: true,
      headerName: "ID",
      minWidth: 50,
      flex: 1,
      sortable: false,
      renderCell: (data) => {
        return <div style={{ fontSize: "14px" }}>{data?.row?.sub_cat_id}</div>;
      },
    },
    {
      field: "sub_cat_name",
      resizable: true,
      headerName: "SUBCATEGORY NAME",
      // description: "This column has a value getter and is not sortable.",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (data) => {
        return (
          <div style={{ fontSize: "14px", color: "grey" }}>
            {" "}
            {data?.row?.sub_cat_name}
          </div>
        );
      },
    },
    {
      field: "year",
      resizable: true,
      headerName: "YEAR",
      minWidth: 70,
      flex: 1,
      sortable: false,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "grey" }}>
          {data?.row?.year || "-"}
        </div>
      ),
    },
    {
      field: "payed",
      resizable: true,
      headerName: "PAID",
      minWidth: 50,
      flex: 1,
      sortable: true,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#4caf50" }}>
          ${data?.row?.payment_details?.payed}
        </div>
      ),
    },
    {
      field: "peding",
      resizable: true,
      headerName: "PENDING",
      sortable: false,
      minWidth: 50,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", color: "#f9c92b" }}>
          ${data?.row?.payment_details?.pending}
        </div>
      ),
    },
    {
      field: "total",
      resizable: true,
      headerName: "TOTAL",
      sortable: false,
      minWidth: 50,
      flex: 1,
      renderCell: (data) => (
        <div style={{ fontSize: "14px", fontWeight: "bolder" }}>
          ${data?.row?.payment_details?.total}
        </div>
      ),
    },
    {
      field: "products",
      resizable: true,
      headerName: "PRODUCTS",
      sortable: false,
      minWidth: 50,
      renderCell: (data) => (
        <div
          style={{
            fontSize: "14px",
            color: "#2555ef",
            fontWeight: "bolder",
            textDecoration: "underline",
            cursor: "pointer",
            // cursor: data?.row?.prodCount != 0 ? "pointer" : "",
          }}
        >
          {data?.row?.prodCount}
        </div>
      ),
    },
    {
      field: "action",
      resizable: true,
      headerName: `${" "}`,
      sortable: false,
      minWidth: 15,
      renderCell: () => (
        <div style={{ cursor: "pointer" }}>
          <Action
            onEditClick={() => {
              setEdit(true);
              setEditClicked(true);
            }}
            onDeleteClick={() => {
              setDeleteClicked(true);
              setOpenAlert(true);
            }}
            onActiveClick={() => {
              setOpenAlert(true);
            }}
            checkActive={true}
          />
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    searchRequest(searchText, table, setList);
  }, [searchText, table]);

  return (
    <div className="activated-ledger">
      <div className="ledger-table" style={{ height: "fit-content" }}>
        <div className="table-title">{list[0]?.led_account?.led_acc_name}</div>
        <div className="home-table-container mt-0 ">
          <MyTable
            className="family-table"
            rows={list}
            columns={columns}
            pageSize={6}
            loading={loading}
            rowHeight={65}
            onClickEvent={(params, event) => {
              event.defaultMuiPrevented = true;
              setData(params?.row);
              setSubId(params?.row?._id);
              const object = {
                ledgerId: params?.row?.led_account,
                ledgerName: ledgerName,
                subId: params?.row?._id,
                subName: params?.row?.sub_cat_name,
              };
              if (params?.field === "products")
                history.push(`/product-details/${params?.row?.id}`, object);
            }}
          >
            Rows per page: {rowsPerPage}
          </MyTable>
          <AlertDialog
            open={openAlert}
            handleClose={handleCloseDialog}
            onDecline={() => {
              setOpenAlert(false);
            }}
            onAccept={() => {
              deleteClicked ? handleDelete() : handleChange();
            }}
            title={"Are you sure?"}
          />
        </div>
      </div>
    </div>
  );
};

export default ActivatedSubCategories;
